import { render, staticRenderFns } from "./dependentInclusionSave.vue?vue&type=template&id=44407850&scoped=true&"
import script from "./dependentInclusionSave.vue?vue&type=script&lang=js&"
export * from "./dependentInclusionSave.vue?vue&type=script&lang=js&"
import style0 from "./dependentInclusionSave.vue?vue&type=style&index=0&id=44407850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44407850",
  null
  
)

export default component.exports